import { z } from 'zod';
/**
 * Zod schemas for knowledge-base endpoints.
 */
export const CreateKnowledgeBaseItemRequestSchema = z
    .object({
    ownerKind: z.enum(['support_ai', 'agent', 'content_calendar', 'crm_sales', 'agent_profile']),
    ownerId: z.string().uuid(),
    kind: z.enum(['text', 'gdoc', 'gsheet']),
    title: z.string().trim().min(1).max(200),
    source: z.string().min(1).max(200_000),
})
    .refine((d) => {
    if (d.kind === 'gdoc' || d.kind === 'gsheet') {
        // Source must look like a Google URL for these kinds.
        return /^https?:\/\/(docs|drive|sheets)\.google\.com\//i.test(d.source);
    }
    return true;
}, { message: 'gdoc/gsheet source must be a Google Docs / Sheets URL', path: ['source'] });
export const UpdateKnowledgeBaseItemRequestSchema = z
    .object({
    title: z.string().trim().min(1).max(200).optional(),
    contentText: z.string().max(200_000).optional(),
    refresh: z.boolean().optional(),
})
    .refine((d) => Object.keys(d).length > 0, {
    message: 'At least one field must be provided',
});
export const KnowledgeBaseItemIdParamSchema = z.object({
    id: z.string().uuid(),
});
export const KnowledgeBaseListQuerySchema = z.object({
    ownerKind: z.enum(['support_ai', 'agent', 'content_calendar', 'crm_sales', 'agent_profile']),
    ownerId: z.string().uuid(),
});
//# sourceMappingURL=knowledge-base.schema.js.map